var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('editor',{staticClass:"editor",attrs:{"init":_vm.editorInit},model:{value:(_vm.localContent),callback:function ($$v) {_vm.localContent=$$v},expression:"localContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }